import React from "react";
import { Routes, Route } from "react-router-dom";
import UserBlogList from "./components/UserBlogList";
import UserBlogDetails from "./components/UserBlogDetails";

const UserBlogPage = () => {
  return (
    <div className="min-h-screen bg-white p-6">
      <div className="bg-[#54B0AF]">
        <h1 className="text-3xl font-bold text-center text-white mb-6">
          StocAI Blogs
        </h1>
      </div>

      <Routes>
        <Route path="/" element={<UserBlogList />} />
        <Route path="/:id" element={<UserBlogDetails />} />
      </Routes>
    </div>
  );
};

export default UserBlogPage;
